var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-page',{attrs:{"style-fn":_vm.getAreaDimension}},[_c('div',{staticClass:"row q-mt-sm q-mx-auto max-container-width",style:(`min-height: ${_vm.areaHeight ? `${_vm.areaHeight}px` : '75vh'}`)},[_c('div',{staticClass:"col bg-white border-radius-4 border-box q-py-sm q-px-md"},[_c('ScheduleCalendar')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }